'use client'

import { useRef } from "react";
import ListingWithFilters from "./ListingWithFilters";

export default function DealerListing(props) {
  
  const ref = useRef()
  
  return <ListingWithFilters ref={ref} {...props}></ListingWithFilters>
  
}